import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { getThemeColorScheme } from 'owa-color-utils/lib/colorUtils';

import styles from './CalendarMonthDayCell.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export default observer(function CalendarMonthDayCell({
    hideTodayEmphasis,
    isSelected,
    dateText,
    dayId,
    isToday,
    isPastDate,
    children,
}: {
    hideTodayEmphasis?: boolean;
    isSelected?: boolean;
    dateText: string;
    dayId: string;
    isToday: boolean;
    isPastDate: boolean;
    children: JSX.Element;
}) {
    const itemClass = classNames(
        styles.dayCellContent,
        { dayCellToday: isToday && !hideTodayEmphasis },
        { pastDay: isPastDate },
        { selected: isSelected }
    );

    const headerClass = classNames(styles.dayCellHeaderAnchor, { selected: isSelected });

    // Note: quickComposeController expects to find elements with the id as given below.
    // text is aria-hidden so that we don't stop on it in scan mode, since the items themselves all have date information
    return (
        <div className={itemClass}>
            <div
                className={styles.dayCellText}
                style={
                    isSelected && isToday && !hideTodayEmphasis
                        ? { color: getThemeColorScheme().accessibleText.calLighterBackground }
                        : undefined
                }>
                <div id={'header_' + dayId} className={headerClass}>
                    <span aria-hidden={true}>{dateText}</span>
                    {children}
                </div>
            </div>
        </div>
    );
});
